import React, { useState, useRef, useEffect } from "react";
import Img from "../Fitnessimg/about-2.png";

const About = () => {
    const [activeTab, setActiveTab] = useState('tab-1');
    const statsTabRef = useRef(null);

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        
        // Scroll to stats tab only when it's being activated
        if (tabId === 'tab-3' && statsTabRef.current) {
            setTimeout(() => {
                statsTabRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
            }, 100); // Small delay to allow tab switch to complete
        }
    };

    // Auto-scroll to stats tab if it's already active when component mounts
    useEffect(() => {
        if (activeTab === 'tab-3' && statsTabRef.current) {
            statsTabRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    }, [activeTab]);

    return (
        <div className="container-fluid about pt-5">
            <div className="container pt-5">
                <div className="row g-5">
                    <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
                        <div className="about-content h-100">
                            <h4 className="text-primary">Influencer Profile</h4>
                            <h1 className="display-4 text-white mb-4">Connect with me across all social platforms</h1>
                            
                            {/* Bio section moved here above tabs */}
                            <div className="bio-section mb-4 p-4" style={{backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '5px'}}>
                                <h5 className="text-primary mb-3">About Me</h5>
                                <p className="text-white">
                                    Fitness enthusiast & lifestyle content creator with 1.2M+ followers across platforms. 
                                    I create engaging content to inspire and entertain my audience. 
                                    Let's collaborate and grow together!
                                </p>
                            </div>

                            <div className="tab-class pb-4">
                                <ul className="nav d-flex mb-2">
                                    <li className="nav-item mb-3">
                                        <button 
                                            className={`d-flex py-2 ${activeTab === 'tab-1' ? 'active' : ''}`}
                                            onClick={() => handleTabClick('tab-1')}
                                        >
                                            <span style={{width: "150px"}}>Basic Info</span>
                                        </button>
                                    </li>
                                    <li className="nav-item mb-3">
                                        <button 
                                            className={`d-flex py-2 mx-3 ${activeTab === 'tab-2' ? 'active' : ''}`}
                                            onClick={() => handleTabClick('tab-2')}
                                        >
                                            <span style={{width: "150px"}}>Social Media</span>
                                        </button>
                                    </li>
                                    <li className="nav-item mb-3">
                                        <button 
                                            className={`d-flex py-2 ${activeTab === 'tab-3' ? 'active' : ''}`}
                                            onClick={() => handleTabClick('tab-3')}
                                        >
                                            <span style={{width: "150px"}}>Statistics</span>
                                        </button>
                                    </li>
                                </ul>
                                <div className="tab-content">
                                    {/* Basic Info Tab */}
                                    <div id="tab-1" className={`tab-pane fade ${activeTab === 'tab-1' ? 'show active' : ''}`}>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex align-items-center border-top border-bottom py-4">
                                                    <span className="fas fa-user text-white fa-4x me-4"></span>
                                                    <div>
                                                        <p className="mb-1"><strong>Full Name:</strong> Jane Doe</p>
                                                        <p className="mb-1"><strong>Username:</strong> @janedoe</p>
                                                        <p className="mb-1"><strong>Date of Birth:</strong> January 1, 1990</p>
                                                        <p className="mb-1"><strong>Location:</strong> Los Angeles, CA, USA</p>
                                                        <p className="mb-0"><strong>Website:</strong> www.janedoe.com</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Social Media Tab */}
                                    <div id="tab-2" className={`tab-pane fade ${activeTab === 'tab-2' ? 'show active' : ''}`}>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex align-items-center border-top border-bottom py-4">
                                                    <span className="fas fa-share-alt text-white fa-4x me-4"></span>
                                                    <div>
                                                        <p className="mb-2"><i className="fab fa-instagram me-2"></i> <strong>Instagram:</strong> <a href="https://instagram.com/janedoe" className="text-white">@janedoe</a></p>
                                                        <p className="mb-2"><i className="fab fa-tiktok me-2"></i> <strong>TikTok:</strong> <a href="https://tiktok.com/@janedoe" className="text-white">@janedoe</a></p>
                                                        <p className="mb-2"><i className="fab fa-youtube me-2"></i> <strong>YouTube:</strong> <a href="https://youtube.com/janedoe" className="text-white">Jane Doe Channel</a></p>
                                                        <p className="mb-2"><i className="fab fa-twitter me-2"></i> <strong>Twitter:</strong> <a href="https://twitter.com/janedoe" className="text-white">@janedoe</a></p>
                                                        <p className="mb-2"><i className="fab fa-facebook me-2"></i> <strong>Facebook:</strong> <a href="https://facebook.com/janedoe" className="text-white">Jane Doe Page</a></p>
                                                        <p className="mb-2"><i className="fab fa-linkedin me-2"></i> <strong>LinkedIn:</strong> <a href="https://linkedin.com/in/janedoe" className="text-white">Jane Doe Profile</a></p>
                                                        <p className="mb-0"><i className="fab fa-snapchat me-2"></i> <strong>Snapchat:</strong> <a href="#" className="text-white">@janedoe</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Statistics Tab */}
                                    <div 
                                id="tab-3" 
                                ref={statsTabRef}
                                className={`tab-pane fade ${activeTab === 'tab-3' ? 'show active' : ''}`}
                                style={{ 
                                    transition: 'all 0.5s ease',
                                    transform: activeTab === 'tab-3' ? 'translateY(0)' : 'translateY(20px)',
                                    opacity: activeTab === 'tab-3' ? 1 : 0
                                }}
                            >
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center border-top border-bottom py-4">
                                            <span className="fas fa-chart-line text-white fa-4x me-4"></span>
                                            <div>
                                                <h5 className="text-primary mb-3">Audience Analytics</h5>
                                                
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <h6 className="text-white">Follower Statistics</h6>
                                                        <ul className="list-unstyled">
                                                            <li className="mb-2">
                                                                <strong>Total Followers:</strong> 1.8M (aggregate across platforms)
                                                            </li>
                                                            <li className="mb-2">
                                                                <strong>Platform Breakdown:</strong>
                                                                <ul>
                                                                    <li>Instagram: 850K</li>
                                                                    <li>TikTok: 650K</li>
                                                                    <li>YouTube: 200K</li>
                                                                    <li>Twitter: 75K</li>
                                                                    <li>Facebook: 25K</li>
                                                                </ul>
                                                            </li>
                                                            <li className="mb-2">
                                                                <strong>Engagement Rate:</strong> 7.8% average
                                                                <ul>
                                                                    <li>Average Likes: 65K per post</li>
                                                                    <li>Average Comments: 2.1K per post</li>
                                                                    <li>Average Shares: 3.5K per post</li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    
                                                    <div className="col-md-6">
                                                        <h6 className="text-white">Audience Demographics</h6>
                                                        <ul className="list-unstyled">
                                                            <li className="mb-2">
                                                                <strong>Age Range:</strong>
                                                                <ul>
                                                                    <li>13-17: 8%</li>
                                                                    <li>18-24: 42%</li>
                                                                    <li>25-34: 35%</li>
                                                                    <li>35-44: 12%</li>
                                                                    <li>45+: 3%</li>
                                                                </ul>
                                                            </li>
                                                            <li className="mb-2">
                                                                <strong>Gender Breakdown:</strong>
                                                                <ul>
                                                                    <li>Female: 68%</li>
                                                                    <li>Male: 30%</li>
                                                                    <li>Other/Not Specified: 2%</li>
                                                                </ul>
                                                            </li>
                                                            <li className="mb-2">
                                                                <strong>Top Locations:</strong>
                                                                <ul>
                                                                    <li>United States: 45%</li>
                                                                    <li>United Kingdom: 15%</li>
                                                                    <li>Canada: 10%</li>
                                                                    <li>Australia: 8%</li>
                                                                    <li>Other: 22%</li>
                                                                </ul>
                                                            </li>
                                                            <li>
                                                                <strong>Top Interests:</strong> Fitness (72%), Travel (65%), Nutrition (58%), Fashion (45%), Tech (30%)
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                
                                                <div className="mt-3">
                                                    <h6 className="text-white">Content Performance</h6>
                                                    <ul className="list-unstyled">
                                                        <li className="mb-1"><strong>Best Performing Content:</strong> Workout tutorials (avg. 12% engagement)</li>
                                                        <li className="mb-1"><strong>Posting Frequency:</strong> 4-5x/week on Instagram, Daily on TikTok</li>
                                                        <li><strong>Optimal Posting Times:</strong> Weekdays 7-9AM & 6-8PM (local time)</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                </div>
                            </div>
                            
                            <div className="row g-4 align-items-center">
                                <div className="col-sm-6">
                                    <a href="#" className="btn btn-primary py-3 px-5"> <span>Contact Me</span></a>
                                </div>
                                <div className="col-sm-6">
                                    <div className="d-flex flex-shrink-0 ps-4">
                                        <a href="#" className="btn btn-light btn-lg-square position-relative wow tada" data-wow-delay=".9s">
                                            <i className="fa fa-envelope fa-2x"></i>
                                            <div className="position-absolute" style={{top: "5px", right: "5px"}}>
                                                <span><i className="fa fa-comment-dots text-dark"></i></span>
                                            </div>
                                        </a>
                                        <div className="d-flex flex-column ms-3">
                                            <span>Email Me Directly</span>
                                            <a href="mailto:contact@janedoe.com"><span className="text-white">contact@janedoe.com</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 wow fadeInUp" data-wow-delay="0.2s">
                        <div className="about-img h-100">
                            <div className="about-img-inner d-flex h-100">
                                <img src={Img} className="img-fluid w-100" style={{objectFit: "cover"}} alt="Influencer Profile"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;